import { render, staticRenderFns } from "./breakdown-instance.vue?vue&type=template&id=9933588a&scoped=true"
import script from "./breakdown-instance.vue?vue&type=script&lang=js"
export * from "./breakdown-instance.vue?vue&type=script&lang=js"
import style0 from "./breakdown-instance.vue?vue&type=style&index=0&id=9933588a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9933588a",
  null
  
)

export default component.exports